// extracted by mini-css-extract-plugin
export default {"wrapper":"TDSqk","header":"hAbaS","footer":"Cm_Pk","wrapperIcon":"Eci5D","iconFurniture":"SNT1x","contentWrapper":"D7zuq ZdH1P","heading":"yOxMg","text":"aEH_v","link":"Tamp9"};